{
	"clientInvoices": {
		"title": "Notas fiscais de {{clientName}}",
		"submitButton": "Emitir notas",
		"name": "Consumidores",
		"issuedAt": "Data e Hora",
		"links": "Links",
		"loading": "Carregando...",
		"noInvoices": "Não há notas emitidas para exibir",
		"somethingWrong": "Algo de errado aconteceu",
		"updatePage": "Atualize a página e tente novamente",
		"openPdf": "Abrir PDF",
		"openCoupon": "Abrir Cupom",
		"onSubmitEmailForm": "Enviar notas fiscais por email",
		"email": "Email",
		"send": "Enviar"
	},
	"clientTransactions": {
		"title": "Extrato do cliente '{{clientName}}'",
		"date": "Hora",
		"product": "Produtos",
		"sellerName": "Vendedor",
		"buyers": "Compradores",
		"refunded": "Estornado?"
	}
}
